"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIsAuthenticated = exports.useAuthToken = exports.getIsAuthenticated = exports.getAuthToken = void 0;
var _Cookie = _interopRequireDefault(require("../../../packages/Cookie"));
var _env = _interopRequireDefault(require("../../../utilities/env"));
var _safeConfig = require("../config/safe-config");
const getAuthToken = function () {
  var _ref;
  const NODE_ENV = (0, _env.default)("NODE_ENV");
  const isProduction = NODE_ENV === "production";
  const [id_token] = (0, _Cookie.default)("id_token");
  const [id_token_tmnab2cqa] = (0, _Cookie.default)("id_token_tmnab2cqa");
  const [id_token_local] = !isProduction ? (0, _Cookie.default)("id_token_local") : [null];
  return (_ref = id_token_local !== null && id_token_local !== void 0 ? id_token_local : id_token) !== null && _ref !== void 0 ? _ref : id_token_tmnab2cqa;
};
exports.getAuthToken = getAuthToken;
const useAuthToken = function () {
  var _ref2;
  const {
    NODE_ENV
  } = (0, _safeConfig.useSafeConfigSlice)(["NODE_ENV"]);
  const isProduction = NODE_ENV === "production";
  const [id_token] = (0, _Cookie.default)("id_token");
  const [id_token_tmnab2cqa] = (0, _Cookie.default)("id_token_tmnab2cqa");
  const [id_token_local] = !isProduction ? (0, _Cookie.default)("id_token_local") : [null];
  return (_ref2 = id_token_local !== null && id_token_local !== void 0 ? id_token_local : id_token) !== null && _ref2 !== void 0 ? _ref2 : id_token_tmnab2cqa;
};
exports.useAuthToken = useAuthToken;
const getIsAuthenticated = function () {
  return !!getAuthToken();
};
exports.getIsAuthenticated = getIsAuthenticated;
const useIsAuthenticated = function () {
  return !!useAuthToken();
};
exports.useIsAuthenticated = useIsAuthenticated;